import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const sOptionalsControllerEndpoint = 'Optionals';
const sSubLotOptionalsControllerEndpoint = 'NegotiationSubLotOptionals';
const sCarOptionalsControllerEndpoint = 'CarOptionals';
const sFPControllerEndpoint = 'FirmPurchases';

export class OptionalsAPI {

  getAllOptionals(searchBy = '') {
    let params = {};
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sOptionalsControllerEndpoint + '/GetAllOptionals', { params });
  }

  getOptionalsByL2Id(L2Id) {
    return axios.get(getBackendURL() + sSubLotOptionalsControllerEndpoint + '/GetOptionalsByL2Id?L2Id=' + L2Id);
  }

  updateOptionalsByL2Id(L2Id, optDTO) {
    return axios.put(getBackendURL() + sSubLotOptionalsControllerEndpoint + '/UpdateBulkOptionalsLotL4?L2Id=' + L2Id, optDTO);
  }

  getOptionalsByL4Id(L4Id) {
    return axios.get(getBackendURL() + sCarOptionalsControllerEndpoint + '/GetOptionalsByL4Id?L4Id=' + L4Id);
  }

  updateOptionalsByL4Id(L4Id, optDTO) {
    return axios.put(getBackendURL() + sCarOptionalsControllerEndpoint + '/UpdateCarOptionalsL4?L4Id=' + L4Id, optDTO);
  }

  getNegotiatedAnnouncedOptionalsByL1Id(L1Id) {
    return axios.get(getBackendURL() + sFPControllerEndpoint + '/GetNegotiatedAnnouncedOptionalsByL1Id?L1Id=' + L1Id);
  }

}

export default OptionalsAPI


// WEBPACK FOOTER //
// ./src/API/OptionalsAPI.js